import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { selectCompatibleBorderOptions } from '../../../_redux-borders';
import { selectPapersOptionsForSize } from '../../../_redux-papers';
import { VariantOption } from '../../../VariantOption';
import { VariantRadioGroup } from '../../variant-radio-group/VariantRadioGroup';
import { ChangeVariantWindowStep } from '../ChangeVariantWindowStep';
import styles from '../ChangeVariantWindow.module.scss';

const _ChangePaperStep = ({
    imageUrl, options, borderOptions,
    setShowBorderStep ,setBorderId, onChange,
    paperId, stepper
}: Props) => {

    const isMobile = useMobile();

    useEffect(() => {

        setShowBorderStep(borderOptions.length > 1);

        if (borderOptions.length === 1) {
            setBorderId(borderOptions[0].value);
        }
    }, [setShowBorderStep, borderOptions, setBorderId]);

    return (
        <ChangeVariantWindowStep imageUrl={imageUrl} className={styles.container} stepper={stepper}>
            <VariantRadioGroup
                selected={paperId}
                onChange={onChange}
                options={options}
                aspectWidth={1}
                aspectHeight={1} />
        </ChangeVariantWindowStep>
    );
};

type OwnProps = {
    stepper?: () => JSX.Element;
    imageUrl?: string;
    sizeId: string | undefined;
    paperId: string | undefined;
    onChange: (paperId: string) => void;
    setBorderId: (borderId: string) => void;
    setShowBorderStep: (show: boolean) => void;
};

type Props = OwnProps & {
    options: VariantOption[];
    borderOptions: VariantOption[];
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    options: selectAvailableOptions(state, ownProps.sizeId),
    borderOptions: selectCompatibleBorderOptions(state, ownProps.sizeId, ownProps.paperId)
});

export const ChangePaperStep = connect(
    mapStateToProps
)(_ChangePaperStep);

const selectAvailableOptions = createSelector([
    selectPapersOptionsForSize
], papers => papers.filter(p => p.available));